// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  background: #ede9fe !important;
  min-height: 100vh;
  color: #0f172a;
  padding-bottom: 3rem;
  padding-top: 0;
  margin-top: 0;
}

/* Override any parent container backgrounds */
body,
.app,
.main-content {
  background: #ede9fe !important;
}

html[data-theme="dark"] .home-page {
  background: #02030a;
  color: #e5e7eb;
}

.metrics-section {
  max-width: 1200px;
  margin: 3rem auto;
  padding: 2rem;
  background: #d6c3d9;
  border-radius: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  box-shadow: 0 10px 30px rgba(55, 11, 59, 0.15);
  border: 2px solid #c4b1c7;
}

html[data-theme="dark"] .metrics-section {
  background: #0b1220;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.35);
  color: #e5e7eb;
}

html[data-theme="dark"] .metric-label {
  color: #a3aab7;
}

html[data-theme="dark"] .metric-value {
  color: #f8fafc;
}

.metric {
  text-align: center;
}

.metric-value {
  font-size: 2.25rem;
  font-weight: 700;
  margin: 0;
  color: #370b3b;
}

.metric-label {
  margin: 0;
  letter-spacing: 0.2em;
  font-size: 0.85rem;
  color: #4c1d95;
}

html[data-theme="dark"] .courses-section {
  background: #05060c;
}

.section-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.45rem;
}

.section-heading h2 {
  margin: 0 0 0.75rem;
  font-size: 2.5rem;
  font-family: var(--font-family-heading);
  color: #370b3b;
  font-weight: 700;
}

.section-heading p {
  margin: 0 0 2rem;
  color: #475569;
  font-size: 1.125rem;
  line-height: 1.6;
  max-width: 700px;
}

html[data-theme="dark"] .section-heading p {
  color: #94a3b8;
}

.modes-section {
  background: #f8f9fa;
  padding: 4rem 2rem;
  border-radius: 2rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  margin: 4rem auto;
  max-width: 1400px;
}

.modes-wrap {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  align-items: start;
}

@media (min-width: 1024px) {
  .modes-wrap {
    grid-template-columns: 1fr 1.5fr;
  }
}

.modes-left {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  text-align: center;
}

.modes-text h2 {
  margin: 0 0 1rem;
  font-size: 2.25rem;
  font-family: var(--font-family-heading);
  color: #370b3b;
  line-height: 1.2;
  font-weight: 700;
}

.modes-text p {
  margin: 0.5rem 0 0;
  color: #4f5a6b;
  line-height: 1.6;
  max-width: 420px;
}

.mode-illustration {
  width: 100%;
  max-width: 400px;
  aspect-ratio: 4/3;
  border-radius: 1.5rem;
  overflow: hidden;
  border: 2px solid #370b3b;
  background: #fff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
}

.mode-illustration img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hybrid-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.65rem 1.2rem;
  background: #d6c3d9;
  color: #370b3b;
  border-radius: 999px;
  font-weight: 600;
  width: fit-content;
  border-color: #370b3b;
}

.hybrid-icon {
  width: 28px;
  height: 28px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: rgba(11, 99, 255, 0.12);
  color: #370b3b;
}

.modes-right {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  justify-items: stretch;
}

.mode-card {
  background: #ffffff;
  padding: 2rem;
  border-radius: 1.35rem;
  border: 2px solid #370b3b;
  box-shadow: 0 26px 42px rgba(15, 23, 42, 0.15);
  display: flex;
  gap: 1.2rem;
  align-items: flex-start;
  min-height: 180px;
  min-width: 0;

}

.mode-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #e0f2fe;
  display: grid;
  place-items: center;
  color: #0d6efd;
  flex-shrink: 0;
}

.mode-content h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.mode-content p {
  margin: 0.45rem 0 0;
  color: #370b3b;
  line-height: 1.55;
  font-size: 1rem;
}

html[data-theme="dark"] .modes-section {
  background: #071022;
  border-color: rgba(148, 163, 184, 0.18);
}

html[data-theme="dark"] .modes-text h2 {
  color: #e5e7eb;
}

html[data-theme="dark"] .modes-text p {
  color: #a3aab7;
}

html[data-theme="dark"] .hybrid-pill {
  background: rgba(89, 166, 255, 0.14);
  color: #9cc9ff;
}

html[data-theme="dark"] .hybrid-icon {
  background: rgba(89, 166, 255, 0.18);
  color: #9cc9ff;
}

html[data-theme="dark"] .mode-card {
  background: #0a0f1c;
  border-color: rgba(148, 163, 184, 0.18);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);
}

html[data-theme="dark"] .mode-content h3 {
  color: #e5e7eb;
}

html[data-theme="dark"] .mode-content p {
  color: #a3aab7;
}

@media (max-width: 900px) {
  .modes-wrap {
    grid-template-columns: 1fr;
  }
  .modes-right {
    grid-template-columns: 1fr;
  }
  .modes-left {
    flex-direction: column;
    align-items: flex-start;
  }
  .mode-illustration {
    width: 100%;
    height: auto;
  }
}

.courses-section {
  max-width: 1400px;
  margin: 4rem auto;
  padding: 0 2rem;
}

.courses-section .section-heading h2 {
  margin: 0 0 0.4rem;
}

.courses-section .section-heading p {
  margin: 0 0 1.15rem;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin: 0;
  align-items: stretch;
}

.courses-grid .course-card {
  background: #d6c3d9;
  border-radius: 1.25rem;
  overflow: hidden;
  box-shadow: 0 10px 10px rgba(15, 23, 42, 0.12);
  border: 1px solid rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  border-color: #370b3b;
  min-width: 0;
  height: 100%;
}

.courses-grid .course-image {
  aspect-ratio: 4 / 3;
  min-height: 180px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.courses-grid .course-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.courses-grid .course-card .course-body {
  padding: 1.05rem 1rem 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
}

.courses-grid .course-card h3 {
  margin: 0.35rem 0 0.15rem;
  line-height: 1.2;
}

.courses-grid .course-card p {
  color: #475467;
  margin: 0;
  line-height: 1.45;
}

.courses-grid .course-card .course-cta {
  align-self: flex-start;
  margin-top: auto;
  padding: 0.55rem 1.35rem;
  border-radius: 999px;
  border: none;
  background: #370b3b;
  color: #fff;
  font-weight: 600;
  transition: transform 0.2s ease;
}

.courses-grid .course-card .course-cta:hover {
  transform: translateY(-2px);
  color: #f59e0b;
}

.cta-section {
  background: linear-gradient(135deg, #370b3b 0%, #5a1761 100%);
  color: #ffffff;
  max-width: 1200px;
  margin: 4rem auto 0;
  border-radius: 2rem;
  padding: 3rem 2.5rem;
  box-shadow: 0 20px 50px rgba(55, 11, 59, 0.3);
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  text-align: center;
}

@media (min-width: 768px) {
  .cta-section {
    grid-template-columns: 1.5fr 1fr;
    text-align: left;
  }
}

.cta-section > div:first-child {
  text-align: center;
}

.cta-section h2 {
  margin: 0;
  font-size: 2.3rem;
  font-family: var(--font-family-heading);
  font-weight: 800;
  line-height: 1.15;
  color: #ffffff;
}

.cta-section p {
  margin: 0.85rem auto 0;
  max-width: 620px;
  line-height: 1.6;
  font-size: 0.98rem;
  color: rgba(255, 255, 255, 0.95);
}

.cta-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

@media (min-width: 768px) {
  .cta-actions {
    justify-content: flex-end;
  }
}

.btn {
  border-radius: 12px;
  padding: 0.65rem 1.3rem;
  font-weight: 700;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 0.9rem;
  line-height: 1;
  transition: transform 0.15s ease, opacity 0.15s ease;
  white-space: nowrap;
}

#cta-journey {
  background: #370b3b;
}

.btn:hover {
  transform: translateY(-1px);
  color: #f59e0b;
  opacity: 0.96;
}

.btn.primary {
  background: #ffffff;
  color: #0d6efd;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.15);
}

.btn.secondary {
  background: transparent;
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 900px) {
  .cta-section {
    grid-template-columns: 1fr;
    row-gap: 1.2rem;
    padding: 2rem 1.5rem;
    margin: 2rem 1rem;
  }

  .cta-actions {
    justify-content: center;
    flex-wrap: wrap;
  }
}

html[data-theme="dark"] #cta-journey {
  background: #370b3b;
}

/* Force CTA secondary button to look like a button */
.cta-section .btn.secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0.65rem 1.3rem;
  border-radius: 12px;

  background: transparent;
  color: #ffffff;

  border: 1.5px solid rgba(255, 255, 255, 0.75);
  cursor: pointer;

  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1;
  white-space: nowrap;
}

.cta-section .btn.secondary:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #f59e0b;
}

@media (min-width: 1025px) and (max-width: 1400px) {
  .courses-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .courses-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .hero-content {
    padding: 2rem;
  }

  .metrics-section {
    padding: 1rem;
  }

  .courses-grid {
    grid-template-columns: 1fr;
  }

  .courses-grid .course-image {
    min-height: 220px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Home/home.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,aAAa;AACf;;AAEA,8CAA8C;AAC9C;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;;AAEd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,gCAAgC;IAChC,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,uBAAuB;EACvB,mBAAmB;;EAEnB,uBAAuB;EACvB,cAAc;;EAEd,6CAA6C;EAC7C,eAAe;;EAEf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".home-page {\r\n  background: #ede9fe !important;\r\n  min-height: 100vh;\r\n  color: #0f172a;\r\n  padding-bottom: 3rem;\r\n  padding-top: 0;\r\n  margin-top: 0;\r\n}\r\n\r\n/* Override any parent container backgrounds */\r\nbody,\r\n.app,\r\n.main-content {\r\n  background: #ede9fe !important;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .home-page {\r\n  background: #02030a;\r\n  color: #e5e7eb;\r\n}\r\n\r\n.metrics-section {\r\n  max-width: 1200px;\r\n  margin: 3rem auto;\r\n  padding: 2rem;\r\n  background: #d6c3d9;\r\n  border-radius: 1.5rem;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 2rem;\r\n  box-shadow: 0 10px 30px rgba(55, 11, 59, 0.15);\r\n  border: 2px solid #c4b1c7;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .metrics-section {\r\n  background: #0b1220;\r\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.35);\r\n  color: #e5e7eb;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .metric-label {\r\n  color: #a3aab7;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .metric-value {\r\n  color: #f8fafc;\r\n}\r\n\r\n.metric {\r\n  text-align: center;\r\n}\r\n\r\n.metric-value {\r\n  font-size: 2.25rem;\r\n  font-weight: 700;\r\n  margin: 0;\r\n  color: #370b3b;\r\n}\r\n\r\n.metric-label {\r\n  margin: 0;\r\n  letter-spacing: 0.2em;\r\n  font-size: 0.85rem;\r\n  color: #4c1d95;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .courses-section {\r\n  background: #05060c;\r\n}\r\n\r\n.section-heading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 0.45rem;\r\n}\r\n\r\n.section-heading h2 {\r\n  margin: 0 0 0.75rem;\r\n  font-size: 2.5rem;\r\n  font-family: var(--font-family-heading);\r\n  color: #370b3b;\r\n  font-weight: 700;\r\n}\r\n\r\n.section-heading p {\r\n  margin: 0 0 2rem;\r\n  color: #475569;\r\n  font-size: 1.125rem;\r\n  line-height: 1.6;\r\n  max-width: 700px;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .section-heading p {\r\n  color: #94a3b8;\r\n}\r\n\r\n.modes-section {\r\n  background: #f8f9fa;\r\n  padding: 4rem 2rem;\r\n  border-radius: 2rem;\r\n  border: 1px solid #e2e8f0;\r\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\r\n  margin: 4rem auto;\r\n  max-width: 1400px;\r\n}\r\n\r\n.modes-wrap {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 3rem;\r\n  align-items: start;\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .modes-wrap {\r\n    grid-template-columns: 1fr 1.5fr;\r\n  }\r\n}\r\n\r\n.modes-left {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.modes-text h2 {\r\n  margin: 0 0 1rem;\r\n  font-size: 2.25rem;\r\n  font-family: var(--font-family-heading);\r\n  color: #370b3b;\r\n  line-height: 1.2;\r\n  font-weight: 700;\r\n}\r\n\r\n.modes-text p {\r\n  margin: 0.5rem 0 0;\r\n  color: #4f5a6b;\r\n  line-height: 1.6;\r\n  max-width: 420px;\r\n}\r\n\r\n.mode-illustration {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  aspect-ratio: 4/3;\r\n  border-radius: 1.5rem;\r\n  overflow: hidden;\r\n  border: 2px solid #370b3b;\r\n  background: #fff;\r\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);\r\n}\r\n\r\n.mode-illustration img {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.hybrid-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.55rem;\r\n  padding: 0.65rem 1.2rem;\r\n  background: #d6c3d9;\r\n  color: #370b3b;\r\n  border-radius: 999px;\r\n  font-weight: 600;\r\n  width: fit-content;\r\n  border-color: #370b3b;\r\n}\r\n\r\n.hybrid-icon {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 10px;\r\n  display: grid;\r\n  place-items: center;\r\n  background: rgba(11, 99, 255, 0.12);\r\n  color: #370b3b;\r\n}\r\n\r\n.modes-right {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 1.5rem;\r\n  justify-items: stretch;\r\n}\r\n\r\n.mode-card {\r\n  background: #ffffff;\r\n  padding: 2rem;\r\n  border-radius: 1.35rem;\r\n  border: 2px solid #370b3b;\r\n  box-shadow: 0 26px 42px rgba(15, 23, 42, 0.15);\r\n  display: flex;\r\n  gap: 1.2rem;\r\n  align-items: flex-start;\r\n  min-height: 180px;\r\n  min-width: 0;\r\n\r\n}\r\n\r\n.mode-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 12px;\r\n  background: #e0f2fe;\r\n  display: grid;\r\n  place-items: center;\r\n  color: #0d6efd;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.mode-content h3 {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n}\r\n\r\n.mode-content p {\r\n  margin: 0.45rem 0 0;\r\n  color: #370b3b;\r\n  line-height: 1.55;\r\n  font-size: 1rem;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .modes-section {\r\n  background: #071022;\r\n  border-color: rgba(148, 163, 184, 0.18);\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .modes-text h2 {\r\n  color: #e5e7eb;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .modes-text p {\r\n  color: #a3aab7;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .hybrid-pill {\r\n  background: rgba(89, 166, 255, 0.14);\r\n  color: #9cc9ff;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .hybrid-icon {\r\n  background: rgba(89, 166, 255, 0.18);\r\n  color: #9cc9ff;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .mode-card {\r\n  background: #0a0f1c;\r\n  border-color: rgba(148, 163, 184, 0.18);\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .mode-content h3 {\r\n  color: #e5e7eb;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .mode-content p {\r\n  color: #a3aab7;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .modes-wrap {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .modes-right {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .modes-left {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  .mode-illustration {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n}\r\n\r\n.courses-section {\r\n  max-width: 1400px;\r\n  margin: 4rem auto;\r\n  padding: 0 2rem;\r\n}\r\n\r\n.courses-section .section-heading h2 {\r\n  margin: 0 0 0.4rem;\r\n}\r\n\r\n.courses-section .section-heading p {\r\n  margin: 0 0 1.15rem;\r\n}\r\n\r\n.courses-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 1.5rem;\r\n  margin: 0;\r\n  align-items: stretch;\r\n}\r\n\r\n.courses-grid .course-card {\r\n  background: #d6c3d9;\r\n  border-radius: 1.25rem;\r\n  overflow: hidden;\r\n  box-shadow: 0 10px 10px rgba(15, 23, 42, 0.12);\r\n  border: 1px solid rgba(15, 23, 42, 0.05);\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-color: #370b3b;\r\n  min-width: 0;\r\n  height: 100%;\r\n}\r\n\r\n.courses-grid .course-image {\r\n  aspect-ratio: 4 / 3;\r\n  min-height: 180px;\r\n  border-bottom: 1px solid rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.courses-grid .course-image img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n.courses-grid .course-card .course-body {\r\n  padding: 1.05rem 1rem 1.15rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  flex: 1;\r\n}\r\n\r\n.courses-grid .course-card h3 {\r\n  margin: 0.35rem 0 0.15rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n.courses-grid .course-card p {\r\n  color: #475467;\r\n  margin: 0;\r\n  line-height: 1.45;\r\n}\r\n\r\n.courses-grid .course-card .course-cta {\r\n  align-self: flex-start;\r\n  margin-top: auto;\r\n  padding: 0.55rem 1.35rem;\r\n  border-radius: 999px;\r\n  border: none;\r\n  background: #370b3b;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.courses-grid .course-card .course-cta:hover {\r\n  transform: translateY(-2px);\r\n  color: #f59e0b;\r\n}\r\n\r\n.cta-section {\r\n  background: linear-gradient(135deg, #370b3b 0%, #5a1761 100%);\r\n  color: #ffffff;\r\n  max-width: 1200px;\r\n  margin: 4rem auto 0;\r\n  border-radius: 2rem;\r\n  padding: 3rem 2.5rem;\r\n  box-shadow: 0 20px 50px rgba(55, 11, 59, 0.3);\r\n  overflow: hidden;\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .cta-section {\r\n    grid-template-columns: 1.5fr 1fr;\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.cta-section > div:first-child {\r\n  text-align: center;\r\n}\r\n\r\n.cta-section h2 {\r\n  margin: 0;\r\n  font-size: 2.3rem;\r\n  font-family: var(--font-family-heading);\r\n  font-weight: 800;\r\n  line-height: 1.15;\r\n  color: #ffffff;\r\n}\r\n\r\n.cta-section p {\r\n  margin: 0.85rem auto 0;\r\n  max-width: 620px;\r\n  line-height: 1.6;\r\n  font-size: 0.98rem;\r\n  color: rgba(255, 255, 255, 0.95);\r\n}\r\n\r\n.cta-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .cta-actions {\r\n    justify-content: flex-end;\r\n  }\r\n}\r\n\r\n.btn {\r\n  border-radius: 12px;\r\n  padding: 0.65rem 1.3rem;\r\n  font-weight: 700;\r\n  border: 1px solid transparent;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  line-height: 1;\r\n  transition: transform 0.15s ease, opacity 0.15s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n#cta-journey {\r\n  background: #370b3b;\r\n}\r\n\r\n.btn:hover {\r\n  transform: translateY(-1px);\r\n  color: #f59e0b;\r\n  opacity: 0.96;\r\n}\r\n\r\n.btn.primary {\r\n  background: #ffffff;\r\n  color: #0d6efd;\r\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.btn.secondary {\r\n  background: transparent;\r\n  color: #ffffff;\r\n  border-color: rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .cta-section {\r\n    grid-template-columns: 1fr;\r\n    row-gap: 1.2rem;\r\n    padding: 2rem 1.5rem;\r\n    margin: 2rem 1rem;\r\n  }\r\n\r\n  .cta-actions {\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\nhtml[data-theme=\"dark\"] #cta-journey {\r\n  background: #370b3b;\r\n}\r\n\r\n/* Force CTA secondary button to look like a button */\r\n.cta-section .btn.secondary {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  padding: 0.65rem 1.3rem;\r\n  border-radius: 12px;\r\n\r\n  background: transparent;\r\n  color: #ffffff;\r\n\r\n  border: 1.5px solid rgba(255, 255, 255, 0.75);\r\n  cursor: pointer;\r\n\r\n  font-weight: 700;\r\n  font-size: 0.9rem;\r\n  line-height: 1;\r\n  white-space: nowrap;\r\n}\r\n\r\n.cta-section .btn.secondary:hover {\r\n  background: rgba(255, 255, 255, 0.12);\r\n  color: #f59e0b;\r\n}\r\n\r\n@media (min-width: 1025px) and (max-width: 1400px) {\r\n  .courses-grid {\r\n    grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  }\r\n}\r\n\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .courses-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .hero-content {\r\n    padding: 2rem;\r\n  }\r\n\r\n  .metrics-section {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .courses-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .courses-grid .course-image {\r\n    min-height: 220px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
